import React, { Component } from 'react'
import './404.css'

class NotFound extends Component {
  render () {
    return (
      <div className='err404'>
        <div className='err404__content'>
          <h1>Error 404</h1>
          <p>Esta página no existe.</p>
        </div>
      </div>
    )
  }
}

export default NotFound
